export default "__VITE_ASSET__CnWk3aYP__"